export default __webpack_public_path__ + "static/media/img2.41056605.png";